import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as actions from 'pages/CommunitySelectedPage/actions';
import { useActions } from 'hooks/useActions';
import { redirectToCheckout } from 'functions/redirectToCheckout';
import { Modal, Body } from 'components/Modals/modalElements';
import { FooterButton } from 'components/Modals/FreecodeModals/FreecodeAuthModal/freecodeModalElements';
import { Spinner } from 'components/Spinner/Spinner';
import {
  List,
  ListItem,
  CheckIcon,
  CourseModalHeading,
  DiamondImage,
  FlexContainer,
  DiscountPrice,
  ActualPrice,
  PriceContainer,
  AwaitLine,
} from './styles';
import { Images } from 'assets/images';

export default function PurchaseCourseModal({ close, course }) {
  const { purchaseCourse } = useActions(actions);
  const { loading, coursePayment } = useSelector((state) => state.CommunitySelectedPageReducer);

  useEffect(() => {
    if (coursePayment.id) redirectToCheckout(coursePayment);
  }, [coursePayment]);

  return (
    <Modal isFreecodeModal isCourseBenefitModal>
      <Body isCoursePurchaseModal>
        {loading ? (
          <Spinner
            title="Please wait while your payment is processing"
            text="Do not refresh / reload the page until processing is done..."
          />
        ) : (
          <>
            <CourseModalHeading>
              <DiamondImage src={Images.diamond} />
            </CourseModalHeading>
            <CourseModalHeading isPurchaseModal>Elevate Your Skills</CourseModalHeading>
            <List>
              <ListItem isPurchaseModal>
                <CheckIcon className="fa-solid fa-check" isPurchaseModal />
                All modules of the course
              </ListItem>
              <ListItem isPurchaseModal>
                <CheckIcon className="fa-solid fa-check" isPurchaseModal />
                Always accessible from the profile
              </ListItem>
            </List>
            <PriceContainer>
              <FlexContainer>
                <DiscountPrice>${course.price.discountPrice['USD']}</DiscountPrice>
                &nbsp;&nbsp;
                <ActualPrice>${course.price.actualPrice['USD']}</ActualPrice>
              </FlexContainer>
              <AwaitLine>Full Course Access Awaits</AwaitLine>
            </PriceContainer>
            <FooterButton isCoursePurchaseButton onClick={() => purchaseCourse(course._id, { currency: 'USD' })}>
              Get Started Today
            </FooterButton>
            <FooterButton isCoursePurchaseCancelButton onClick={() => close()}>
              Cancel
            </FooterButton>
          </>
        )}
      </Body>
    </Modal>
  );
}
